module.exports = __webpack_public_path__ + "img/group-work.76e94f83.svg";